export default __webpack_public_path__ + "static/media/photo--sm--91.aab90150.jpg";